// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  "payloadEndpoint": "",
  "redirectSSOUrl": "",
  "registerEndpoint": "",
   "apiBaseUrl":"https://lifeadminweb.azurewebsites.net/"
  //"apiBaseUrl":"http://localhost:63445/"
  //"apiBaseUrl":"https://localhost:44323/"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts